<template>
    <v-card>
        <v-card-text>
            <p class="text-body-2 grey--text text--darken-1">
                Adjunte el memorando que respalda la creación de esta cuenta o cualquier cambio posterior
                (permisos, reactivación, baja). Los memorandos quedan como evidencia: no se editan ni se eliminan.
            </p>

            <v-form ref="form" v-model="valido" v-if="puedeEditar">
                <v-row dense>
                    <v-col cols="12" sm="4" md="3">
                        <v-text-field
                            v-model="modelo.numero" label="N.° de memorando" placeholder="Ej. MEMO-GRH-045-2026"
                            outlined dense maxlength="100" prepend-inner-icon="tag"
                        />
                    </v-col>
                    <v-col cols="12" sm="8" md="5">
                        <v-text-field
                            v-model="modelo.descripcion" label="Motivo" placeholder="Ej. Creación de la cuenta"
                            outlined dense maxlength="300" prepend-inner-icon="description"
                            :rules="[(v) => (!!v && v.trim().length >= 5) || 'Describa el motivo (mínimo 5 caracteres)']"
                        />
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-file-input
                            v-model="modelo.archivo" label="Archivo (PDF o imagen, máx. 10 MB)"
                            accept="application/pdf,image/jpeg,image/png"
                            outlined dense show-size prepend-icon="" prepend-inner-icon="attach_file"
                            :rules="reglasArchivo"
                        />
                    </v-col>
                </v-row>
                <v-progress-linear v-if="guardando" :value="progreso" height="5" rounded color="success" class="mb-2"/>
                <v-btn small color="success" :loading="guardando" @click="guardar">
                    <v-icon small left>cloud_upload</v-icon> Registrar memorando
                </v-btn>
            </v-form>

            <v-data-table
                dense class="elevation-1 mt-5"
                :headers="columnas" :items="memorandos" :loading="cargando"
                item-key="memorando_id" hide-default-footer disable-pagination
            >
                <template v-slot:item="{ item }">
                    <tr>
                        <td class="text-no-wrap">{{ item.fecha_crea | fechaESPHora }}</td>
                        <td>{{ item.numero || '—' }}</td>
                        <td>{{ item.descripcion }}</td>
                        <td>{{ item.registrado_por }}</td>
                        <td class="text-center">
                            <v-btn small outlined color="info" :href="item.archivo_url" target="_blank" :title="item.archivo_nombre">
                                <v-icon small left>visibility</v-icon> Ver
                            </v-btn>
                        </td>
                    </tr>
                </template>
                <template v-slot:no-data>
                    <v-alert dense type="warning" outlined class="text-center mt-3">
                        Esta cuenta todavía no tiene memorandos registrados.
                    </v-alert>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "ParticipantesAdministradoresMemorandos",
    props: {
        getParams: {type: Object, required: true},
        puedeEditar: {type: Boolean, default: false},
    },
    data() {
        return {
            valido: true,
            cargando: false,
            guardando: false,
            progreso: 0,
            memorandos: [],
            modelo: {numero: "", descripcion: "", archivo: null},
            reglasArchivo: [
                (v) => !!v || 'Adjunte el memorando',
                (v) => !v || v.size <= 10 * 1024 * 1024 || 'El archivo no puede superar 10 MB',
            ],
            columnas: [
                {text: 'Fecha', value: 'fecha_crea', sortable: false},
                {text: 'N.° memorando', value: 'numero', sortable: false},
                {text: 'Motivo', value: 'descripcion', sortable: false},
                {text: 'Registrado por', value: 'registrado_por', sortable: false},
                {text: 'Archivo', align: 'center', sortable: false},
            ],
        }
    },
    methods: {
        listar() {
            this.cargando = true;
            const params = {persona_id: this.getParams.persona_id};

            window.axios.get('/cuentas/memorandos', {params}).then(response => {
                if (response.data.success) {
                    this.memorandos = response.data.data;
                } else {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(() => this.$toast.error("No se pudo listar los memorandos."))
                .finally(() => {
                    this.cargando = false;
                });
        },
        guardar() {
            if (!this.$refs.form.validate()) return;

            const datos = new FormData();
            datos.append("persona_id", this.getParams.persona_id);
            datos.append("numero", this.modelo.numero || "");
            datos.append("descripcion", this.modelo.descripcion.trim());
            datos.append("archivo", this.modelo.archivo);

            this.guardando = true;
            this.progreso = 0;

            window.axios.post('/cuentas/memorandos', datos, {
                onUploadProgress: (e) => {
                    if (e.total) this.progreso = Math.round((e.loaded * 100) / e.total);
                },
            }).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.$refs.form.reset();
                    this.listar();
                } else {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    const cuerpo = error.response && error.response.data;
                    const detalle = cuerpo && cuerpo.data && typeof cuerpo.data === "object"
                        ? Object.values(cuerpo.data).flat().join(" ")
                        : (cuerpo && cuerpo.message);
                    this.$toast.error(detalle || "No se pudo guardar el memorando.");
                })
                .finally(() => {
                    this.guardando = false;
                });
        },
    },
    created() {
        this.listar();
    },
}
</script>
